import { z } from "zod";
import { optionalUnlessRequired, type FieldDescriptor } from "./types.js";

const configSchema = z.object({
  minuteStep: z.number().int().min(1).max(60).default(1),
});

export const timeField: FieldDescriptor<z.infer<typeof configSchema>> = {
  type: "time",
  label: "Time",
  category: "date_time",
  icon: "Clock",
  configSchema,
  valueSchema: (_config, isRequired) =>
    optionalUnlessRequired(
      z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/, "Enter a valid time (HH:MM)"),
      isRequired,
    ),
  defaultConfig: { minuteStep: 1 },
  supportsProfileBinding: false,
  defaultSearchable: false,
  renderHints: {},
};
